module.exports = __webpack_public_path__ + "static/media/SVGClass.8d33b9dd.svg";